import api from './api';

export const getMovies = ({ full = false, limit = 20, page = 1, search = '', genre = '' } = {}) =>
  api.get(`/api/v1/movies?full=${full}&limit=${limit}&page=${page}&search=${search}&genre=${genre}`);
export const getMovie = (id) => api.get(`/api/v1/movies/${id}?by=id`);
export const getMovieByUrl = (url) => api.get(`/api/v1/movies/${url}?by=url`);
export const getMoviesForSelect = () => api.get('/api/v1/movies?include=titulo_original');
export const createMovie = (payload) => api.post('/api/v1/movies', payload);
export const updateMovie = (id, payload) => api.patch(`/api/v1/movies/${id}`, payload);
export const deleteMovie = (id) => api.delete(`/api/v1/movies/${id}`);
export const assignVideoToMovie = (payload) => api.post('/api/v1/movies/assign-video', payload);
